import { getInfo } from '@/api/login'
import { getToken, removeToken } from '@/utils/cookie'
import { resetRouter } from '@/router'
import Vue from 'vue'

const STEP = {
  BASE_INFO: "baseInfo",
  ATTEND: "attend",
  ARRIVE_LEAVE: "arriveLeave",
};
const checkTimeBetween = function (start, end, now) {
  if (!start || !end) {
    return false;
  }
  const startDate = new Date(start.replace(/-/g, "/"));
  const endDate = new Date(end.replace(/-/g, "/"));
  if (now >= startDate && now <= endDate) {
    return true;
  }
  return false;
};
const checkTimeBefore = function (start, now) {
  if (!start) {
    return false;
  }
  const startDate = new Date(start.replace(/-/g, "/"));
  if (startDate <= now) {
    return true;
  }
  return false;
};
const checkTimeAfter = function (start, now) {
  if (!start) {
    return false;
  }
  const startDate = new Date(start.replace(/-/g, "/"));
  if (startDate >= now) {
    return true;
  }
  return false;
};

const state = {
  token: '',
  name: '',
  nameEn: '',
  photo: '',
  phone: '',
  email: '',
  userId: '',
  conferenceId: '',
  type: '',
  peopleType: '',
  nationality: '',
  company: '',
  companyEn: '',
  job: '',
  jobEn: '',
  needUpdateInfo: '',
  status: '',
  promiseHealth: '',
  joinState: '',
  signState: 0,
  certState: 0,
  activityPlan: [],
  interviewPlan: [],
  location: '',
  idNumber: '',
  nameField: '',
  enNameField: '',
  surname: '',
  enSurname: '',
  gender: '',
  activeStep: "",
  lastStep: "",
  show1: false,
  show2: false,
  show3: false,
  showCount: 0,
  showNative: false,
  edit1: false,
  edit2: false,
  edit3: false,
  editCount: 0,
  submit1: false,
  submit2: false,
  submit3: false
}
const mutations = {
  SET_TOKEN: (state, token) => {
    Vue.set(state, 'token', token)
  },
  SET_NAME: (state, name) => {
    Vue.set(state, 'name', name)
  },
  SET_NAME_EN: (state, nameEn) => {
    Vue.set(state, 'nameEn', nameEn)
  },
  SET_PHOTO: (state, photo) => {
    Vue.set(state, 'photo', photo)
  },
  SET_PHONE: (state, phone) => {
    Vue.set(state, 'phone', phone)
  },
  SET_EMAIL: (state, email) => {
    Vue.set(state, 'email', email)
  },
  SET_USERID: (state, userId) => {
    Vue.set(state, 'userId', userId)
  },
  SET_CONFERENCEID: (state, conferenceId) => {
    Vue.set(state, 'conferenceId', conferenceId)
  },
  SET_TYPE: (state, type) => {
    Vue.set(state, 'type', type)
  },
  SET_PEOPLE_TYPE: (state, peopleType) => {
    Vue.set(state, 'peopleType', peopleType)
  },
  SET_NATIONALITY: (state, nationality) => {
    Vue.set(state, 'nationality', nationality)
  },
  SET_COMPANY: (state, company) => {
    Vue.set(state, 'company', company)
  },
  SET_COMPANY_EN: (state, companyEn) => {
    Vue.set(state, 'companyEn', companyEn)
  },
  SET_JOB: (state, job) => {
    Vue.set(state, 'job', job)
  },
  SET_JOB_EN: (state, jobEn) => {
    Vue.set(state, 'jobEn', jobEn)
  },
  SET_NEED_UPDATE_INFO: (state, needUpdateInfo) => {
    Vue.set(state, 'needUpdateInfo', needUpdateInfo)
  },
  SET_STATUS: (state, status) => {
    Vue.set(state, 'status', status)
  },
  SET_PROMISE_HEALTH: (state, promiseHealth) => {
    Vue.set(state, 'promiseHealth', promiseHealth)
  },
  SET_JOIN_STATE: (state, joinState) => {
    Vue.set(state, 'joinState', joinState)
  },
  SET_SIGN_STATE: (state, signState) => {
    Vue.set(state, 'signState', signState)
  },
  SET_CERT_STATE: (state, certState) => {
    Vue.set(state, 'certState', certState)
  },
  SET_ACTIVITY_PLAN: (state, activityPlan) => {
    Vue.set(state, 'activityPlan', activityPlan)
  },
  SET_INTERVIEW_PLAN: (state, interviewPlan) => {
    Vue.set(state, 'interviewPlan', interviewPlan)
  },
  SET_LOCATION: (state, location) => {
    Vue.set(state, 'location', location)
  },
  SET_ID_NUMBER: (state, idNumber) => {
    Vue.set(state, 'idNumber', idNumber)
  },
  SET_NAME_FIELD: (state, nameField) => {
    Vue.set(state, 'nameField', nameField)
  },
  SET_EN_NAME_FIELD: (state, enNameField) => {
    Vue.set(state, 'enNameField', enNameField)
  },
  SET_SURNAME: (state, surname) => {
    Vue.set(state, 'surname', surname)
  },
  SET_EN_SURNAME: (state, enSurname) => {
    Vue.set(state, 'enSurname', enSurname)
  },
  SET_GENDER: (state, gender) => {
    Vue.set(state, 'gender', gender)
  },
  SET_ACTIVE_STEP: (state, activeStep) => {
    Vue.set(state, "activeStep", activeStep);
  },
  SET_LAST_STEP: (state, lastStep) => {
    Vue.set(state, "lastStep", lastStep);
  },
  SET_SHOW_1: (state, show1) => {
    Vue.set(state, "show1", show1);
  },
  SET_SHOW_2: (state, show2) => {
    Vue.set(state, "show2", show2);
  },
  SET_SHOW_3: (state, show3) => {
    Vue.set(state, "show3", show3);
  },
  SET_SHOW_COUNT: (state, showCount) => {
    Vue.set(state, "showCount", showCount);
  },
  SET_SHOW_NATIVE: (state, showNative) => {
    Vue.set(state, "showNative", showNative);
  },
  SET_EDIT_1: (state, edit1) => {
    Vue.set(state, "edit1", edit1);
  },
  SET_EDIT_2: (state, edit2) => {
    Vue.set(state, "edit2", edit2);
  },
  SET_EDIT_3: (state, edit3) => {
    Vue.set(state, "edit3", edit3);
  },
  SET_EDIT_COUNT: (state, editCount) => {
    Vue.set(state, "editCount", editCount);
  },
  SET_SUBMIT_1: (state, submit1) => {
    Vue.set(state, "submit1", submit1);
  },
  SET_SUBMIT_2: (state, submit2) => {
    Vue.set(state, "submit2", submit2);
  },
  SET_SUBMIT_3: (state, submit3) => {
    Vue.set(state, "submit3", submit3);
  },
}

const actions = {
  setUserToken ({ commit, state }) {
    commit('SET_TOKEN', getToken(state.conferenceId + state.type))
  },

  // get user info
  getInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        if (response) {
          const { data } = response
          if (!data) {
            reject(new Error('Verification failed, please Login again.'))
          }
          const {
            name, nameEn, photo, phone, email, userId, conferenceId, type, peopleType, nationality, company, companyEn,
            job, jobEn, needUpdateInfo, status, promiseHealth, joinState, signState, certState, activityPlan, interviewPlan, location, idNumber,
            nameField, enNameField, surname, enSurname, gender,
            baseInfoStartTime,
            baseInfoEndTime,
            attendStartTime,
            attendEndTime,
            arriveLeaveStartTime,
            arriveLeaveEndTime,
            baseInfoSubmit,
            attendSubmit,
            arriveLeaveSubmit
          } = data
          commit('SET_NAME', name)
          commit('SET_NAME_EN', nameEn)
          commit('SET_PHOTO', photo)
          commit('SET_PHONE', phone)
          commit('SET_EMAIL', email)
          commit('SET_USERID', userId)
          commit('SET_CONFERENCEID', conferenceId)
          commit('SET_TYPE', type)
          commit('SET_PEOPLE_TYPE', peopleType)
          commit('SET_NATIONALITY', nationality)
          commit('SET_COMPANY', company)
          commit('SET_COMPANY_EN', companyEn)
          commit('SET_JOB', job)
          commit('SET_JOB_EN', jobEn)
          commit('SET_NEED_UPDATE_INFO', needUpdateInfo)
          commit('SET_STATUS', status)
          commit('SET_PROMISE_HEALTH', promiseHealth)
          commit('SET_JOIN_STATE', joinState)
          commit('SET_SIGN_STATE', signState)
          commit('SET_CERT_STATE', certState)
          if (activityPlan) {
            commit('SET_ACTIVITY_PLAN', activityPlan.split(','))
          } else {
            commit('SET_ACTIVITY_PLAN', [])
          }
          if (interviewPlan) {
            commit('SET_INTERVIEW_PLAN', interviewPlan.split(','))
          } else {
            commit('SET_INTERVIEW_PLAN', [])
          }
          commit('SET_LOCATION', location)
          commit('SET_ID_NUMBER', idNumber)
          commit('SET_NAME_FIELD', nameField)
          commit('SET_EN_NAME_FIELD', enNameField)
          commit('SET_SURNAME', surname)
          commit('SET_EN_SURNAME', enSurname)
          commit('SET_GENDER', gender)
          commit('SET_SUBMIT_1', baseInfoSubmit == 1)
          commit('SET_SUBMIT_2', attendSubmit == 1)
          commit('SET_SUBMIT_3', arriveLeaveSubmit == 1)
          // 计算哪个可以查看，哪个可以修改
          let activeStep = "";
          let lastStep = "";
          let show1 = false;
          let show2 = false;
          let show3 = false;
          let showCount = 0;
          let showNative = false;
          let edit1 = false;
          let edit2 = false;
          let edit3 = false;
          let editCount = 0;
          // 如果三个时间至少设置了任意一个
          if (
            (baseInfoStartTime && baseInfoEndTime) ||
            (attendStartTime && attendEndTime) ||
            (location !== "广州本地" &&
              arriveLeaveStartTime &&
              arriveLeaveEndTime)
          ) {
            const now = new Date();
            // 是否能够修改完全按照时间来，时间为空的时候也是false
            if (checkTimeBetween(baseInfoStartTime, baseInfoEndTime, now)) {
              if (baseInfoSubmit == 1) {
                edit1 = false;
              } else {
                edit1 = true;
              }
            }
            if (checkTimeBetween(attendStartTime, attendEndTime, now)) {
              edit2 = true;
            }
            if (
              location !== "广州本地" &&
              checkTimeBetween(arriveLeaveStartTime, arriveLeaveEndTime, now)
            ) {
              edit3 = true;
            }
            editCount = (edit1 ? 1 : 0) + (edit2 ? 1 : 0) + (edit3 ? 1 : 0);
            // 是否显示按阶段来
            if (checkTimeBefore(arriveLeaveStartTime, now)) {
              if (location !== "广州本地") {
                show1 = true;
                show2 = true;
                show3 = true;
                showCount = 3;
                activeStep = STEP.BASE_INFO;
                lastStep = STEP.ARRIVE_LEAVE;
              } else {
                show1 = true;
                show2 = true;
                showCount = 2;
                activeStep = STEP.BASE_INFO;
                lastStep = STEP.ATTEND;
              }
            } else if (checkTimeBefore(attendStartTime, now)) {
              show1 = true;
              show2 = true;
              showCount = 2;
              activeStep = STEP.BASE_INFO;
              lastStep = STEP.ATTEND;
            } else if (checkTimeBefore(baseInfoStartTime, now)) {
              show1 = true;
              showCount = 1;
              activeStep = STEP.BASE_INFO;
              lastStep = STEP.BASE_INFO;
            }
          }
          showNative = location !== "广州本地"
          commit("SET_ACTIVE_STEP", activeStep);
          commit("SET_LAST_STEP", lastStep);
          commit("SET_SHOW_1", show1);
          commit("SET_SHOW_2", show2);
          commit("SET_SHOW_3", show3);
          commit("SET_SHOW_COUNT", showCount);
          commit("SET_SHOW_NATIVE", showNative);
          commit("SET_EDIT_1", edit1);
          commit("SET_EDIT_2", edit2);
          commit("SET_EDIT_3", edit3);
          commit("SET_EDIT_COUNT", editCount);
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user removeInfo
  removeInfo ({ commit }) {
    return new Promise((resolve) => {
      commit('SET_NAME', '')
      commit('SET_NAME_EN', '')
      commit('SET_PHOTO', '')
      commit('SET_PHONE', '')
      commit('SET_EMAIL', '')
      commit('SET_USERID', '')
      commit('SET_CONFERENCEID', '')
      commit('SET_TYPE', '')
      commit('SET_PEOPLE_TYPE', '')
      commit('SET_NATIONALITY', '')
      commit('SET_COMPANY', '')
      commit('SET_COMPANY_EN', '')
      commit('SET_JOB', '')
      commit('SET_JOB_EN', '')
      commit('SET_NEED_UPDATE_INFO', '')
      commit('SET_STATUS', '')
      commit('SET_PROMISE_HEALTH', '')
      commit('SET_JOIN_STATE', '')
      commit('SET_SIGN_STATE', 0)
      commit('SET_CERT_STATE', 0)
      commit('SET_ACTIVITY_PLAN', [])
      commit('SET_INTERVIEW_PLAN', [])
      commit('SET_LOCATION', '')
      commit('SET_ID_NUMBER', '')
      commit('SET_NAME_FIELD', '')
      commit('SET_EN_NAME_FIELD', '')
      commit('SET_SURNAME', '')
      commit('SET_EN_SURNAME', '')
      commit('SET_GENDER', '')
      resolve()
    })
  },

  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve) => {
      // logout().then(() => {
      commit('SET_TOKEN', '')
      removeToken(state.conferenceId + state.type)
      resetRouter()

      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken ({ commit, state }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken(state.conferenceId + state.type)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
